import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { ONLINE_SALES_DELIVERY_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const OnlineSalesDeliveryApi = createApi({
  reducerPath: "OnlineSalesDelivery",
  baseQuery,
  tagTypes: ["OnlineSalesDelivery"],
  endpoints: (builder) => ({
    getOnlineSalesDelivery: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: ONLINE_SALES_DELIVERY_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: ONLINE_SALES_DELIVERY_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["OnlineSalesDelivery"],
    }),
    getOnlineSalesDeliveryById: builder.query({
      query: ({ id }) => {
        return {
          url: `${ONLINE_SALES_DELIVERY_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["OnlineSalesDelivery"],
    }),
    addOnlineSalesDelivery: builder.mutation({
      query: (payload) => ({
        url: ONLINE_SALES_DELIVERY_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["OnlineSalesDelivery"],
    }),
    updateOnlineSalesDelivery: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${ONLINE_SALES_DELIVERY_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["OnlineSalesDelivery"],
    }),
    deleteOnlineSalesDelivery: builder.mutation({
      query: (id) => ({
        url: `${ONLINE_SALES_DELIVERY_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["OnlineSalesDelivery"],
    }),
  }),
});

export const {
  useGetOnlineSalesDeliveryQuery,
  useGetOnlineSalesDeliveryByIdQuery,
  useAddOnlineSalesDeliveryMutation,
  useUpdateOnlineSalesDeliveryMutation,
  useDeleteOnlineSalesDeliveryMutation,
} = OnlineSalesDeliveryApi;

export default OnlineSalesDeliveryApi;
